import get from 'lodash/get';
import head from 'lodash/head';

export const getFaceplatesUrl = (card) =>
  get(head(get(card, 'media.faceplates', [])), 'path');
